var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"page-title-content"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.city_show)?_c('div',{staticClass:"city"},[_vm._v(" 选择城市： "),_c('CitySelect',{attrs:{"value":_vm.city},on:{"onChange":_vm.changeCity}})],1):_vm._e()]),_c('el-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }